import { render, staticRenderFns } from "./SwipeRefresh.vue?vue&type=template&id=cc8ce886&scoped=true"
import script from "./SwipeRefresh.vue?vue&type=script&lang=ts"
export * from "./SwipeRefresh.vue?vue&type=script&lang=ts"
import style0 from "./SwipeRefresh.vue?vue&type=style&index=0&id=cc8ce886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8ce886",
  null
  
)

export default component.exports